export default () => ({
  dragField: {
    boxSizing: 'border-box',
    border: '1px solid black',
    position: 'absolute',
  },
});
